import CharacterCount from '@tiptap/extension-character-count';
import Link from '@tiptap/extension-link';
import Placeholder from '@tiptap/extension-placeholder';
import Youtube from '@tiptap/extension-youtube';
import { type Extensions } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import type { IntlShape } from 'react-intl';

import { MAX_CHARACTER_LIMIT } from '../../../constants';
import { XingImage } from './xing-image';
import { XingQuote } from './xing-quote';
import { XingVideo } from './xing-video';

export type ExtensionsOptions = Partial<{
  intl: IntlShape;
  contentPlaceholder: string;
  maxCharacterLimit: number;
}>;

export const getExtensions = (options?: ExtensionsOptions): Extensions => {
  return [
    StarterKit.configure({
      gapcursor: false,
    }),
    Link.configure({
      autolink: false,
      validate: (href) => /^https?:\/\/[a-zA-Z0-9]+\.[a-zA-Z0-9]+/.test(href),
    }),
    Placeholder.configure({
      includeChildren: true,
      showOnlyCurrent: false,
      placeholder: ({ node }) => {
        if (node.type.name === 'quote') {
          return (
            options?.intl?.formatMessage({
              id: 'ARTICLES_ARTICLE_EDITOR_CONTENT_EDITOR_PLACEHOLDER_QUOTE',
            }) ?? ''
          );
        }
        if (node.type.name === 'quoteCaption') {
          return (
            options?.intl?.formatMessage({
              id: 'ARTICLES_ARTICLE_EDITOR_CONTENT_EDITOR_PLACEHOLDER_QUOTE_SOURCE',
            }) ?? ''
          );
        }
        if (node.type.name === 'imageCaption') {
          return (
            options?.intl?.formatMessage({
              id: 'ARTICLES_ARTICLE_EDITOR_CONTENT_EDITOR_PLACEHOLDER_IMAGE_CAPTION',
            }) ?? ''
          );
        }
        if (node.type.name === 'videoCaption') {
          return (
            options?.intl?.formatMessage({
              id: 'ARTICLES_ARTICLE_EDITOR_CONTENT_EDITOR_PLACEHOLDER_VIDEO_CAPTION',
            }) ?? ''
          );
        }

        if (options?.contentPlaceholder) {
          return options.contentPlaceholder;
        }

        const defaultPlaceholder =
          options?.intl?.formatMessage({
            id: 'ARTICLES_ARTICLE_EDITOR_CONTENT_EDITOR_PLACEHOLDER_CONTENT',
          }) ?? '';

        return defaultPlaceholder;
      },
    }),
    XingImage,
    XingVideo,
    Youtube.configure({
      nocookie: true,
    }),
    CharacterCount.configure({
      limit: options?.maxCharacterLimit ?? MAX_CHARACTER_LIMIT,
    }),
    XingQuote,
  ];
};

export { XingImage, XingVideo, XingQuote };
